import { useTranslation } from 'react-i18next';

import { ExportIcon, PrintIcon } from './icons';

/**
 * Take this table away: as a file, or on paper.
 *
 * Two marks rather than two words, because they sit on every table in the
 * application and a pair of buttons repeated eight times should take as little
 * room as it can. What they do is in the tooltip and in what a screen reader
 * announces.
 *
 * Printing is the browser's own, driven by a print stylesheet: everything that
 * is not the table is hidden, and the table prints with its headings repeated
 * on each page. A rendered PDF would look better and would mean a second
 * renderer to keep in step with every screen that has a table.
 */
export function TableTools({
  onExport,
  busy,
  label,
}: {
  /** Absent when there is nothing to write a file from yet. */
  onExport?: () => void;
  busy?: boolean;
  /** What is being taken away, for the tooltip: "экспорт: остатки". */
  label: string;
}) {
  const { t } = useTranslation();

  return (
    <span className="table-tools">
      {onExport && (
        <button
          type="button"
          className="table-tools__button"
          onClick={onExport}
          disabled={busy}
          title={`${t('common.exportXlsx')} — ${label}`}
          aria-label={`${t('common.exportXlsx')} — ${label}`}
        >
          <ExportIcon />
        </button>
      )}
      <button
        type="button"
        className="table-tools__button"
        onClick={() => window.print()}
        title={`${t('common.print')} — ${label}`}
        aria-label={`${t('common.print')} — ${label}`}
      >
        <PrintIcon />
      </button>
    </span>
  );
}
